<ng-container [formGroup]="form">
  <app-form-group [form]="form" [controls]="controls"></app-form-group>
</ng-container>
